"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _loading = require("@/mixins/loading/loading");

var _milkRun = require("@/mixins/milk-run/milk-run");

var _elementUi = require("element-ui");

var _orderDateRange = _interopRequireDefault(require("@/views/milk-run/components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("@/views/milk-run/components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("@/views/milk-run/components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("@/views/milk-run/components/order-table/order-table.vue"));

var _ganttFilter = _interopRequireDefault(require("@/views/milk-run/components/gantt-filter/gantt-filter.vue"));

var _ganttChart = _interopRequireDefault(require("@/views/milk-run/components/gantt-chart/gantt-chart.vue"));

var _planHeader = _interopRequireDefault(require("@/views/milk-run/components/plan-header/plan-header.vue"));

var _planSearch = _interopRequireDefault(require("@/views/milk-run/components/plan-search/plan-search.vue"));

var _orderSummary = _interopRequireDefault(require("@/views/milk-run/components/order-summary/order-summary.vue"));

var _truckSummary = _interopRequireDefault(require("@/views/milk-run/components/truck-summary/truck-summary.vue"));

var _moment = _interopRequireDefault(require("moment"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

var _permission = require("@/mixins/permission/permission");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRManualAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRManualAssignComponent, _Mixins);

  var _super = _createSuper(MRManualAssignComponent);

  function MRManualAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRManualAssignComponent);
    _this = _super.apply(this, arguments);
    _this.isShowFailedOrders = false;
    _this.failedOrders = [];
    _this.isEnableAllTrucks = true;
    _this.selectedPlanId = null;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 240;
    _this.startDate = null;
    _this.endDate = null;
    _this.routeViewOptions = ['plannedRoutes'];
    _this.planViewType = 'daily';
    _this.currentPlanId = null;
    _this.socket = null;
    return _this;
  }

  (0, _createClass2.default)(MRManualAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        top: !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      this.confirmUnsavedChanges(to, from, next);
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }

      var date = this.helper.get(this.$route, 'query.date', null);

      if (this.helper.isUndefined(date)) {
        this.startDate = (0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD');
        this.endDate = (0, _moment.default)(new Date()).add(3, 'days').format('YYYY-MM-DD');
      } else {
        this.startDate = date;
        this.endDate = date;
      }

      this.$planDateRange = [this.startDate, this.endDate];
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.routes = [];
                _context.next = 3;
                return this.$getUnassignedOrders();

              case 3:
                _context.next = 5;
                return this.$getTrucks();

              case 5:
                _context.next = 7;
                return this.$initPlan();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "handleManualAssign",
    value: function () {
      var _handleManualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(planId) {
        var truckObj;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                truckObj = this.getTruckInPlan(this.$selectedTruck);

                if (truckObj) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return this.manualAssignTruck('INIT', null, planId);

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return this.manualAssignTruck('UPDATE', truckObj, planId);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleManualAssign(_x) {
        return _handleManualAssign.apply(this, arguments);
      }

      return handleManualAssign;
    }()
  }, {
    key: "manualAssignTruck",
    value: function () {
      var _manualAssignTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, truckObj, planId) {
        var isNewPlanId, newPlanId, res, prefix, newPlanIds;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isManualAssignLoading = true;
                isNewPlanId = planId === 'newPlanId';
                newPlanId = planId;
                res = null;

                if (!isNewPlanId) {
                  _context3.next = 10;
                  break;
                }

                // const prefix = this.helper.generatePlanId('', this.$userInformation.company.name);
                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, '', this.$userInformation, 'milkrun');
                _context3.next = 8;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 8:
                newPlanIds = _context3.sent;
                newPlanId = this.helper.get(newPlanIds, 'data.0', []);

              case 10:
                if (!(type === 'INIT')) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 13;
                return this.handleNewTruckObj({
                  planId: newPlanId
                });

              case 13:
                res = _context3.sent;

              case 14:
                if (!(type === 'UPDATE')) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 17;
                return this.handleExistingTruckObj({
                  planId: newPlanId,
                  isNewPlanId: isNewPlanId,
                  truckObj: truckObj
                });

              case 17:
                res = _context3.sent;

              case 18:
                if (!this.helper.isUndefined(res)) {
                  _context3.next = 21;
                  break;
                }

                this.isManualAssignLoading = false;
                return _context3.abrupt("return");

              case 21:
                this.$anyChanges = true;
                this.handleFailedOrders(res);
                this.isManualAssignLoading = false;

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function manualAssignTruck(_x2, _x3, _x4) {
        return _manualAssignTruck.apply(this, arguments);
      }

      return manualAssignTruck;
    }()
  }, {
    key: "handleEnableAllTrucks",
    value: function handleEnableAllTrucks() {
      this.isEnableAllTrucks = true;
    }
  }, {
    key: "handleDisableAllTrucks",
    value: function handleDisableAllTrucks() {
      this.isEnableAllTrucks = false;
    }
  }, {
    key: "handleSearchValueIsFound",
    value: function handleSearchValueIsFound(newVal) {
      this.selectedPlanId = newVal;
    }
  }, {
    key: "recalculateTimeList",
    value: function recalculateTimeList(newVal) {
      this.initAutoAddedDays = newVal;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(_ref) {
      var isShowFailedOrders = _ref.isShowFailedOrders,
          failedOrders = _ref.failedOrders;
      this.isShowFailedOrders = isShowFailedOrders;
      this.failedOrders = failedOrders;
      this.$failedOrders = failedOrders;
    }
  }, {
    key: "handleTimeListChanges",
    value: function handleTimeListChanges(startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
    }
  }, {
    key: "handleRouteViewsChanges",
    value: function handleRouteViewsChanges(newVal) {
      this.routeViewOptions = newVal;
    }
  }, {
    key: "handlePlanViewChanges",
    value: function handlePlanViewChanges(newVal) {
      this.planViewType = newVal;
    }
  }, {
    key: "handleCurrentPlanIdChanges",
    value: function handleCurrentPlanIdChanges(newVal) {
      this.currentPlanId = newVal;
    }
  }]);
  return MRManualAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _milkRun.MilkRunMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRManualAssignComponent.prototype, "$isFullscreen", void 0);
MRManualAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRManualAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'gantt-filter': _ganttFilter.default,
    'gantt-chart': _ganttChart.default,
    'plan-header': _planHeader.default,
    'plan-search': _planSearch.default,
    'order-summary': _orderSummary.default,
    'truck-summary': _truckSummary.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog
  }
})], MRManualAssignComponent);
var _default = MRManualAssignComponent;
exports.default = _default;